// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1571":"f68c8d09","6717":"3d124f03"}[chunkId] + ".chunk.css";
};